import { Inline } from '@syl-editor/core-utilities';
import { toRgba } from '@syl-editor/lib/dist/lib/utils/hex';

export function getAttrs(style: string): any {
  const color = toRgba(style);
  if (color) {
    return {
      color,
    };
  }
  return false;
}
const black = 'rgba(0, 0, 0, 1)';
export default class DIYColor extends Inline<any> {
  public name = 'diyColor';

  public tagName = () => 'span';

  public attrs = {
    color: {
      default: `${black}`,
    },
  };

  public parseDOM = [
    {
      style: 'color',
      getAttrs,
    },
    {
      tag: '*[color]',
      getAttrs: (dom: HTMLElement) => getAttrs(dom.getAttribute('color')!),
    },
  ];

  public toDOM = (node: any) => ['span', { style: `color: ${node.attrs.color}` }, 0];
}
